import React from 'react';

interface GlassCTAProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}

const FOCUS = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal focus-visible:ring-offset-2 focus-visible:ring-offset-paper-raised';

/** Onboarding buttons: an ink pill that presses to 0.97, or a quiet text button. */
export function GlassCTA({
  variant = 'primary',
  children,
  disabled,
  className = '',
  ...props
}: GlassCTAProps) {
  if (variant === 'secondary') {
    return (
      <button
        type="button"
        disabled={disabled}
        className={`rounded-full text-sm text-ink-3 transition-colors duration-200 ease-out hover:text-ink disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:text-ink-3 ${FOCUS} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={`group relative rounded-full bg-ink px-8 py-3.5 font-medium text-paper-raised transition-[transform,background-color] duration-200 ease-out hover:bg-ink/90 active:scale-[0.97] motion-reduce:active:scale-100 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-ink ${FOCUS} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
